module.exports = __webpack_public_path__ + "static/media/gladys2.b4d1fb33.mp3";